import jwtDecode from "jwt-decode";
import useGenerateToken from "./GenerateToken";

const useValidateToken = () => {
  const { generateRefreshToken } = useGenerateToken();

  async function checkTokenExpiry() {
    const sessionID = sessionStorage.getItem("SessionID");
    const token = sessionStorage.getItem("Token");
    const refreshToken = sessionStorage.getItem("RefreshToken");

    try {
      if (tokenHasExpired(token)) {
        await generateRefreshToken(sessionID, refreshToken);
      } else {
        return;
      }
    } catch (e) {
      throw e;
    }
  }

  return {
    checkTokenExpiry,
  };
};

export const tokenHasExpired = (jwt) => {
  // Count Down
  const timestamp = parseInt(jwtDecode(jwt)["exp"]) * 1000;
  const expiryDate = new Date(timestamp);

  // Current date
  const now = new Date().getTime();

  // If JWT expired
  if (expiryDate < now) {
    return true;
  }

  return false;
};

export default useValidateToken;
